import { createTransport } from "./transportFactory.js";

const { transport } = createTransport("huddle");

export const huddleTransport = transport;
